import { filled } from './model';
import { Band, SectionIndex } from './ui';

export default function ProcessSection({ steps, index }: { steps: string[]; index: string }) {
  const items = filled(steps);
  if (!items.length) return null;

  return (
    <Band id="process">
      <SectionIndex index={index} title="Process" />
      <ol className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((step, i) => (
          <li key={`${step}-${i}`} className="panel p-4">
            <span className="text-sm font-medium text-signal">{String(i + 1).padStart(2, '0')}</span>
            <p className="mt-2 text-base font-medium leading-snug text-ink">{step}</p>
          </li>
        ))}
      </ol>
    </Band>
  );
}
